import vue from "vue";
import { initialState } from "./initialState";
export default {
    SET_SEARCH_DOCTOR: (state, searchDoctor) => {
        state.searchDoctor = searchDoctor;
    },
    SET_SEARCH_CASHIER: (state, searchCashier) => {
        state.searchCashier = searchCashier;
    },
    SET_SEARCH_RETURN: (state, searchReturn) => {
        state.searchReturn = searchReturn;
    },
    SET_SEARCH_UNIT: (state, searchUnit) => {
        state.searchUnit = searchUnit;
    },
    SET_RETURN_TOTAL: (state, returnTotal) => {
        state.returnTotal = returnTotal;
    },
    SET_CASHIER_TOTAL: (state, cashierTotal) => {
        state.cashierTotal = cashierTotal;
    },
    SET_UNIT_TOTAL: (state, unitTotal) => {
        state.unitTotal = unitTotal;
    },
    SET_DOCTORS: (state, doctors) => {
        state.doctors = doctors;
    },
    SET_CASHIERS: (state, cashiers) => {
        state.cashiers = cashiers;
    },
    SET_INSURANCES: (state, insurances) => {
        state.insurances = insurances;
    },
    SET_SEARCHED_DRS: (state, searchedDrs) => {
        state.searchedDrs = searchedDrs;
    },
    SET_DOCTOR_REPORT_ROWS: (state, doctorReportRows) => {
        state.doctorReportRows = doctorReportRows;
    },
    SET_UNIT_REPORT_ROWS: (state, unitReportRows) => {
        state.unitReportRows = unitReportRows;
    },
    SET_CASHIER_REPORT_ROWS: (state, cashierReportRows) => {
        state.cashierReportRows = cashierReportRows;
    },
    SET_CASHIER_REPORT_ROWS_PRINT: (state, cashierReportRowsPrint) => {
        state.cashierReportRowsPrint = cashierReportRowsPrint;
    },
    SET_RETURN_REPORT_ROWS: (state, returnReportRows) => {
        state.returnReportRows = returnReportRows;
    },
    SET_RETURN_REPORT_ROWS_PRINT: (state, returnReportRowsPrint) => {
        state.returnReportRowsPrint = returnReportRowsPrint;
    },
    SET_COUNT_OF_REFERRALS: (state, countOfReferrals) => {
        state.countOfReferrals = countOfReferrals;
    },
    SET_REFERRAL_WAYS: (state, referralWays) => {
        state.referralWays = referralWays;
    },
    RESET_MODULE (state) { // To reset the entire module
        Object.assign(state, JSON.parse(JSON.stringify(_.cloneDeep(initialState))))
       }
}